import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import {
  AssociatedListProps,
  AssociateRegistryData,
  CheckWorkOrderRegistryParams,
  DetailResponse,
  MatchedWOrkOrdersProps,
} from './types';

export const checkWorkOrderRegistry = (
  params: CheckWorkOrderRegistryParams
): Promise<MatchedWOrkOrdersProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  const url = new URL(`${baseUrl}/api/V1/work-orders/check-registry`);

  url.searchParams.append('registration_number', params.registration_number);
  url.searchParams.append('book', params.book);
  url.searchParams.append('registry_office', params.registry_office);
  if (params.exclude_work_order_id)
    url.searchParams.append(
      'exclude_work_order_id',
      params.exclude_work_order_id.toString()
    );

  return fetch(url, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const checkArchivedRegistry = (
  params: CheckWorkOrderRegistryParams
): Promise<MatchedWOrkOrdersProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  const url = new URL(`${baseUrl}/api/V1/work-orders/search-archived-registry`);

  url.searchParams.append('registration_number', params.registration_number);
  url.searchParams.append('book', params.book);
  url.searchParams.append('registry_office', params.registry_office);
  if (params.exclude_work_order_id)
    url.searchParams.append(
      'exclude_work_order_id',
      params.exclude_work_order_id.toString()
    );

  return fetch(url, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const associateWorkOrderRegistry = (
  data: AssociateRegistryData
): Promise<DetailResponse> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data.bodyData),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${data.osId}/associate`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getAssociatedList = (
  osId: number
): Promise<AssociatedListProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${osId}/associated`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
